import Player from '@vimeo/player';

import globals from'../globals.js';

import load_image from'../helpers/image-loader.js';
import load_video from'../helpers/video-loader.js';

var thumbVimeoPlayers = [];


function thumb_player(){

    var players = document.querySelectorAll('.thumb-player');
    var videos = Array.prototype.slice.call(players);


    videos.forEach(function(vid) {

        var parent = vid.parentNode;
            
        if(!parent.classList.contains('swiper-slide')){
            var parent = vid.parentNode.parentNode;
        }

        var thumbVimeoPlayer = {
            elm: vid,
            id: vid.dataset.id,
            player: false,
            playing: false,
            parent: parent,
            loaded: false,
            loading: false
        };

        thumbVimeoPlayers.push(thumbVimeoPlayer);

           

            if(!thumbVimeoPlayer.elm.classList.contains('autoplay')){
    
                parent.addEventListener('mouseenter', function(){
                    bind_player(thumbVimeoPlayer, false, true);
                });

                parent.addEventListener('mouseleave', function(){
                    bind_player(thumbVimeoPlayer, true, false);
                });

            }else{
                

                bind_player(thumbVimeoPlayer, false, true);
            }
    
    });

};

function bind_player(thumbVimeoPlayer, playing, autoplays){


    if(!thumbVimeoPlayer.player){

        if(!thumbVimeoPlayer.loaded && !thumbVimeoPlayer.loading){
            
            thumbVimeoPlayer.loading = true;

            let autoplay = false;

            const options = {
                id: thumbVimeoPlayer.id,
                resoponsive: true,
                loop: true,
                background: autoplay,
                quality: '540p',
                controls: false,
                muted: 1,
                cache: true,
                dnt: true,
                loading: 'lazy'
            };
            

            const player = new Player(thumbVimeoPlayer.elm, options);
            thumbVimeoPlayer.player = player;

            player.on("play", function(data) {
                thumbVimeoPlayer.parent.classList.add('thumb-playing');
                tthumbVimeoPlayer.playing = true;
            });

            player.on("pause", function(data) {
                thumbVimeoPlayer.playing = false;
            });

            thumbVimeoPlayer.loaded = true;

            
            thumbVimeoPlayer.player.play();

        }

    }else{

        if(thumbVimeoPlayer.loaded){
            
            if(playing){
                thumbVimeoPlayer.parent.classList.remove('thumb-playing');
                thumbVimeoPlayer.player.pause();
            }else{
                thumbVimeoPlayer.parent.classList.add('thumb-playing');
                thumbVimeoPlayer.player.play();
            }

        }

    }

}




export default thumb_player;